import React from 'react';
import { convertDateToVietnameseText } from '@src/utils';
import { StyledPrintOrder } from './index.style';
import Header from './Header';

const PrintOrder = React.forwardRef(
  ({ customer, date, title, children, showFooter = true }, ref) => (
    <StyledPrintOrder ref={ref}>
      <Header title={title} customer={customer} />
      {children}
      {showFooter && (
        <div className="footer-print">
          <div className="signature">
            <p className="date">{convertDateToVietnameseText(date)}</p>
            <p className="doctor-label">Bác sỹ khám bệnh</p>
            <div className="signature-space" />
          </div>
        </div>
      )}
    </StyledPrintOrder>
  ),
);

export default PrintOrder;
